import { useEffect } from 'react';

const useBeforeUnloadBrowserAlert = (shouldAllowLeave?: boolean, message = 'Are you sure you want to leave') => {
  useEffect(() => {
    const listener = (e: BeforeUnloadEvent) => {
      if (shouldAllowLeave) return '';
      e.preventDefault();
      // eslint-disable-next-line no-return-assign
      return (e.returnValue = message);
    };
    window.addEventListener('beforeunload', listener);
    return () => window.removeEventListener('beforeunload', listener);
  });
};

export default useBeforeUnloadBrowserAlert;
